import { getBaseFeature } from '@/assets/style/variable'

const styObj = {
  default: {
    '--wb-page-bg': '#f7f6f9',
    '--wb-change-btn-color': '#9743f3',
  },

  kiko: {
    '--wb-page-bg': '#f7f6f9',
    '--wb-change-btn-color': '#545455',
  },
}

export const pageCssVars = {
  methods: {
    cssVars() {
      if (this.packageName) {
        if (styObj[this.packageName]) {
          return { ...getBaseFeature(), ...styObj[this.packageName] }
        }
        return { ...getBaseFeature(), ...styObj.default }
      }
      return { ...getBaseFeature() }
    },
  },
}
